<template>
  <v-dialog v-model="show_modal" persistent eager max-width="800">
    <v-card>
      <v-form ref="form" v-model="form_status" v-on:submit.prevent="add">
        <v-card-title class="headline">
          {{ $t("officer.config_individual_tuition_fee") }} {{ type_tab == 1 ? 'และค่าอุดหนุนทางการศึกษา' : '' }}(
          {{
            form_mode === FORM_MODES.ADD
              ? $t("config_academic.addnew")
              : $t("config_academic.edit")
          }}
          ) <br />
          {{
            level == 1 ? "ระดับปริญญาตรี" : "ระดับบัณฑิตศึกษา (4+1, โท, เอก)"
          }}
        </v-card-title>

        <hr />

        <v-card-text class="mt-5">
          <v-row>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <v-text-field
                v-bind:label="$t('config_academic.year')"
                v-model="year"
                type="number"
                outlined
                dense
                disabled
            /></v-col>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <v-autocomplete
                v-model="semester"
                v-bind:label="$t('config_academic.semester')"
                v-bind:items="semesters"
                v-bind:item-value="(item) => item.semester"
                v-bind:item-text="(item) => item.semester"
                outlined
                dense
                disabled
              ></v-autocomplete
            ></v-col>
          </v-row>
        </v-card-text>

        <v-card-text class="mt-5">
          <v-row v-if="type_tab == 1 && form_mode === FORM_MODES.ADD">
            <v-col class="pt-0 pb-0" cols="12">
              <v-textarea 
                  v-bind:label="$t('config_medicine.student_id')"
                  placeholder="สามารถกรอกได้หลายรหัสนักศึกษาโดยเว้นวรรคหรือขึ้นบรรทัดใหม่ (ตัวอย่าง: 63000001 63000002)"
                  v-model="student_id_array"
                  outlined
                  dense
                  v-bind:rules="combinedRules"
                  @input="filterInput"
                  rows="3"
              />
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col class="pt-0 pb-0" cols="12" md="4">
              <v-text-field
                v-bind:label="$t('config_medicine.student_id')"
                v-model="student_id"
                outlined
                dense
                v-bind:rules="studentIdRules"
                :disabled="form_mode === FORM_MODES.EDIT"
              />
            </v-col>
            <v-col cols="12" md="4">
              <span
                class="gray--text"
                v-show="student_id != null && student_data.name_th == ''"
                >ไม่พบข้อมูล</span
              >
              <span class="blue--text" v-show="student_data.name_th != ''">
                {{ student_data.prename_th }}{{ student_data.name_th }}
                {{ student_data.surname_th }} </span
              ><br />
              <span
                class="red--text"
                v-show="
                  student_data.name_th != '' &&
                  level == 2 &&
                  student_data.sub_level_id == 1
                "
              >
                (นศ. 4+1)</span
              >
            </v-col>
            <v-col cols="12" md="4">
              <span v-show="student_data.name_th != ''">
                {{ student_data.level_name_th }} :
                {{ student_data.faculty_name }}
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                label="ค่าธรรมเนียมการศึกษา"
                v-model="tuition_fee"
                outlined
                dense
                type="number"
                v-bind:rules="tuitionFeeRules"
              />
            </v-col>
            <v-col v-if="type_tab == 1" cols="12" md="6">
              <v-text-field
                label="ค่าอุดหนุนทางการศึกษา"
                v-model="subsidy_fee"
                outlined
                dense
                type="number"
                v-bind:rules="tuitionFeeRules"
              />
            </v-col>
            <v-col v-if="type_tab != 1" cols="12">
              <v-text-field
                label="หมายเหตุ"
                v-model="remark"
                outlined
                dense
                v-bind:rules="requiredRules"
              />
            </v-col>
            <v-col v-else cols="12">
              <v-textarea
                label="หมายเหตุ"
                v-model="remark"
                outlined
                dense
                rows="2"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pb-5 pr-4">
          <v-spacer></v-spacer>
          <v-icon
            v-show="isNeverRegis === false"
            class="red--text"
            >mdi-alert</v-icon>
          <span v-show="isNeverRegis === false" class="red--text ml-1">
            นศ. ลงทะเบียนเทอม {{ semester }} / {{ year }} แล้วจะไม่สามารถเพิ่มหรือแก้ไขข้อมูลเมนูนี้ได้
          </span>
          <v-btn v-if="type_tab == 1 && form_mode === FORM_MODES.ADD"
            class="ml-5 "
            color="success"
            @click="form_validate()"
            :disabled="
              !form_status
            "
          >
            {{ $t("config_academic.save") }}
          </v-btn>
          <v-btn v-else
            class="ml-5 "
            color="success"
            @click="form_validate()"
            :disabled="
              !form_status ||
              student_data.name_th == '' ||
              isNeverRegis === false
            "
          >
            {{ $t("config_academic.save") }}
          </v-btn>
          <v-btn color="error" @click="show_modal = false">{{
            $t("config_academic.cancel")
          }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { objectTranslator } from "@/helper/translator";
import { getYearsModified } from "@/helper/dateTime";
import validator from "@/helper/validator";
import ConfigProvider from "@/services/config.provider";
import UserProvider from "@/services/user.provider";
import RegistrationProvider from "@/services/registration.provider.js";

const configService = new ConfigProvider();
const userService = new UserProvider();
const registrationService = new RegistrationProvider();
const FORM_MODES = { ADD: 0, EDIT: 1 };
const student_data_template = {
  prename_th: "",
  name_th: "",
  surname_th: "",
  level_name_th: "",
  faculty_name: "",
};

export default {
  name: "ConfigIndividualTuitionFeeAddEditDialog",

  props: {
    toggle_loading: Function,
    fetch_data: Function,
    type_tab: Number,
  },

  data: () => ({
    FORM_MODES,
    semesters: ["1", "2", "3"],

    form_mode: null,
    form_status: null,
    show_modal: false,
    isNeverRegis: true,

    level: null,
    year: null,
    semester: null,
    student_id: null,
    student_id_array: '',
    tuition_fee: null,
    subsidy_fee: null,
    remark: null,
    student_data: student_data_template,

    requiredRules: [validator.required],
    studentIdRules: [validator.required, validator.student_id],
    tuitionFeeRules: [
      (v) => !!v || "Tuition fee is required",
      (v) => (v && v > 0) || "Tuition fee must be a number greater than 0",
    ],
  }),

  components: {},

  computed: {
    combinedRules() {
      return [
        ...this.requiredRules,
        this.checkEightDigitsRule
      ];
    }
  },

  methods: {
    objectTranslator,
    getYearsModified,

    filterInput() {
      this.student_id_array = this.student_id_array.replace(/[^0-9 \n]/g, '');
    },

    checkEightDigitsRule(value) {
      if (!value) return true;

      const items = value.trim().split(/\s+/);
      const isValid = items.every(item => /^[0-9]{8}$/.test(item));

      return isValid || 'รหัสนักศึกษาต้องมี 8 หลักพอดี และคั่นด้วยช่องว่างหรือขึ้นบรรทัดใหม่';
    },

    open_add_modal: function (
      selected_level,
      selected_year,
      selected_semester
    ) {
      this.student_id = null;
      this.student_id_array = '';
      this.tuition_fee = null;
      this.subsidy_fee = null;
      this.remark = null;
      this.form_mode = FORM_MODES.ADD;
      this.level = selected_level;
      this.year = selected_year;
      this.semester = selected_semester;
      this.student_data = student_data_template;
      this.show_modal = true;
    },

    open_edit_modal: function (
      selected_level,
      selected_year,
      selected_semester,
      item
    ) {
      this.form_mode = FORM_MODES.EDIT;
      this.level = selected_level;
      this.year = selected_year;
      this.semester = selected_semester;
      this.student_id = item.student_id;
      this.tuition_fee = item.tuition_fee;
      this.subsidy_fee = item.subsidy_fee;
      this.remark = item.remark;
      this.show_modal = true;
    },

    form_validate: function () {
      this.$refs.form.validate();
      if (this.form_mode === FORM_MODES.ADD) {
        this.add();
      } else if (this.form_mode === FORM_MODES.EDIT) {
        this.edit();
      }
    },

    get_student_data: async function () {
      this.student_data = student_data_template;
      this.loading = true;
      let response = await userService
        .getStudentData(this.student_id)
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        });
        let std_level = response.level_id != "3" ? response.level_id : "2";
      if (
        (response && this.level == std_level) ||
        (this.level == 2 && response.sub_level_id == 1)
      ) {
        this.student_data = response;
        this.check_never_regis();
      } else {
        // this.student_id = null;
      }
      this.loading = false;
    },

    check_never_regis: async function () {
      const data = await registrationService.isNeverRegis({
        student_id: this.student_id,
        year: this.year,
        semester: this.semester,
        level_id: this.student_data.level_id,
        sub_level_id: this.student_data.sub_level_id,
      }).catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        this.loading = false;
        this.error = true;
      });
      this.isNeverRegis = data.status;
    },

    add: async function () {
      // this.show_modal = false;
      this.toggle_loading(true);

      let formattedStudentIds = [];
      if (this.student_id_array) {
        formattedStudentIds = this.student_id_array.trim().split(/\s+/);

        try {
          await userService.checkStudentAndRegis({
            student_id: formattedStudentIds,
            year: this.year,
            semester: this.semester
          });
        } catch (error) {
          this.$toasted.error(JSON.stringify(error.response?.data?.message || "เกิดข้อผิดพลาด"), {
            duration: 0,
          });
          
          this.toggle_loading(false); 
          return; 
        }

        // try {
        //   const checkStudentPromises = formattedStudentIds.map(id => 
        //     userService.getStudentData(id)
        //   );
        //   await Promise.all(checkStudentPromises);

        // } catch (error) {
        //   this.$toasted.error(JSON.stringify(error.response?.data?.message || "เกิดข้อผิดพลาด"), {
        //     duration: 0,
        //   });
          
        //   this.toggle_loading(false); 
        //   return; 
        // }

      } else {
        formattedStudentIds = this.student_id;
      }
      
      let response = await configService
        .setIndividualTuitionFee({
          year: this.year,
          semester: this.semester,
          level: this.level,
          student_id: formattedStudentIds,
          tuition_fee: this.tuition_fee,
          subsidy_fee: this.subsidy_fee,
          remark: this.remark,
        })
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.toggle_loading(false);
        });
        
      this.show_modal = false;

      this.fetch_data();
      if (response && response.status)
        this.$toasted.success(this.$t("toasted.create_successfully"));
      else this.$toasted.error(this.$t("toasted.cannot_create"));
    },

    edit: async function () {
      this.show_modal = false;
      this.toggle_loading(true);

      let response = await configService
        .setIndividualTuitionFee({
          year: this.year,
          semester: this.semester,
          level: this.level,
          student_id: this.student_id,
          tuition_fee: this.tuition_fee,
          subsidy_fee: this.subsidy_fee,
          remark: this.remark,
        })
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.toggle_loading(false);
        });
      this.fetch_data();
      if (response && response.status)
        this.$toasted.success(this.$t("toasted.edit_successfully"));
      else this.$toasted.error(this.$t("toasted.cannot_edit"));
    },
  },

  watch: {
    student_id: {
      handler: function () {
        if (this.student_id.length === 8) this.get_student_data();
      },
    },
  },

  mounted: function () {},
};
</script>
<style scoped>
.warning-text {
  color: white;
  background-color: rgb(226, 162, 42);
  border-radius: 5px;
  padding: 5px;
}
</style>